import { eventChannel, END } from "redux-saga";
import { put, take, call, fork } from "redux-saga/effects";
import axios from "axios";
import { isObject } from "reactstrap/lib/utils";
import { NextServerAPI } from "../../utils";
import actions, { actionTypes } from "../../shell/actions";

export function* getBanks() {
  yield put(actions.loadingBanks());

  yield put(actions.loadedBanks({ banks: { data: [] } }));
}

export function* submitLeads(action) {
  const { data } = action.payload;

  yield put(actions.submitingLeads());
  try {
    const leads = yield call(NextServerAPI, {
      method: "POST",
      path: `/api/user/leads/`,
      data,
    });

    yield put(actions.submittedLeads({ leads }));

    action.callback && action.callback(leads);
  } catch (error) {
    yield put(actions.errorSubmittingLeads());
  }
}

export function* getLocationList(action) {
  const { search } = action.payload;

  yield put(actions.loadingLocationList());

  try {
    const locations = yield call(NextServerAPI, {
      method: "GET",
      path: `/api/osm/?search=${search}`,
    });

    if (action.callback) {
      action.callback(locations);
    }

    yield put(actions.loadedLocationList({ locations }));
  } catch (error) {
    yield put(actions.errorLoadingLocationList());
  }
}

export function* getLatestArticles(action) {
  try {
    const response = yield call(NextServerAPI, {
      method: "GET",
      path: "/api/media/latest-articles/",
    });

    if (response.data.status !== 200) {
      action.callback && action.callback({ success: false, response });
    }

    if (response.data.status !== 404) {
      action.callback && action.callback({ success: true, response });
    }
  } catch (error) {
    action.callback && action.callback({ success: false });
  }
}

export function* getRelatedArticles(action) {
  const { id } = action.payload;

  yield put(actions.loadingRelatedArticles());

  try {
    const response = yield call(NextServerAPI, {
      method: "GET",
      path: `/api/media/related-posts/?id=${id}`,
    });

    yield put(
      actions.loadedRelatedArticles({ data: response.data.posts.nodes })
    );
  } catch (error) {
    yield put(actions.errorLoadingRelatedArticles());
  }
}

export function* getCalculatorArticles(action) {
  const { id } = action.payload;

  yield put(actions.loadingCalculatorArticles());

  try {
    const response = yield call(NextServerAPI, {
      method: "GET",
      path: `/api/media/related-posts/?id=${id}`,
    });

    yield put(
      actions.loadedCalculatorArticles({ data: response.data.posts.nodes })
    );
  } catch (error) {
    yield put(actions.errorLoadingCalculatorArticles());
  }
}

function createUploader({ data, token, URL, shouldNotAuthenticate }) {
  let emit;
  const CHAT_UPLOAD_API_URL = "/api/agents/chat/send-message/";
  const chan = eventChannel((emitter) => {
    emit = emitter;
    return () => {};
  });
  const uploadProgressCb = ({ total, loaded }) => {
    const percentage = Math.round((loaded * 100) / total);
    emit(percentage);
    if (percentage === 100) emit(END);
  };
  const uploadPromise = axios(URL || CHAT_UPLOAD_API_URL, {
    method: "POST",
    ...(shouldNotAuthenticate
      ? {}
      : {
          headers: {
            authorization: `Bearer ${token}`,
          },
        }),
    data,
    onUploadProgress: uploadProgressCb,
  });
  return [uploadPromise, chan];
}

function* uploadProgressWatcher(chan) {
  while (true) {
    const progress = yield take(chan);
    yield put(actions.uploadFilesProgress(progress));
  }
}

function* uploadFiles({ payload, callback }) {
  yield put(actions.uploadFilesStart());
  try {
    const [uploadPromise, chan] = yield call(createUploader, payload);
    yield fork(uploadProgressWatcher, chan);
    const res = yield call(() => uploadPromise);
    callback && callback(res);
    yield put(actions.uploadFilesSuccess());
  } catch (e) {
    yield put(actions.uploadFilesFailed(e));
  }
}

export function* getPaymentLink(action) {
  try {
    const response = yield call(NextServerAPI, {
      method: "POST",
      path: `/api/orders/payment-link-generate/`,
      data: action.payload,
    });

    action.callback && action.callback(response);
  } catch (e) {
    console.error(e);
    action.callback && action.callback(e);
  }
}

export default [
  [actionTypes.GET_BANKS, getBanks],
  [actionTypes.SUBMIT_LEADS, submitLeads],
  [actionTypes.GET_LOCATION_LIST, getLocationList],
  [actionTypes.GET_LATEST_ARTICLES, getLatestArticles],
  [actionTypes.GET_RELATED_ARTICLES, getRelatedArticles],
  [actionTypes.GET_CALCULATOR_ARTICLES, getCalculatorArticles],
  [actionTypes.UPLOAD_FILES, uploadFiles],
  [actionTypes.GET_PAYMENT_LINK, getPaymentLink],
];
